import type { BaseContentProps } from "./types"
import getVideoId from "get-video-id"
import { useMemo } from "react"

export const VideoContent = ({ content }: BaseContentProps) => {
  // youtube video id
  const videoId = useMemo(
    () => getVideoId(content.media?.url ?? "").id,
    [content]
  )

  if (!videoId) {
    return null
  }

  return (
    <div
      style={{
        width: "100%",
        paddingInline: 24,
        position: "relative",
      }}
    >
      <iframe
        title="YouTube video"
        src={`https://www.youtube.com/embed/${videoId}`}
        style={{
          width: "100%",
          height: 200,
          minHeight: 200,
          border: "none",
          backgroundColor: "rgba(255, 255, 255, 0.15)",
          borderRadius: 16,
          position: "relative",
          zIndex: 1,
        }}
      />
    </div>
  )
}
